"use strict";

module.exports = function () {
  let {
    from: t = 0,
    duration: e = 400
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return t > 100 && (t = 100), t < 0 && (t = 0), function (_ref) {
    var _i$children, _i$children$, _i$children$$children;
    let {
      popper: i,
      data: p
    } = _ref;
    let o = (_i$children = i.children) === null || _i$children === void 0 ? void 0 : (_i$children$ = _i$children[0]) === null || _i$children$ === void 0 ? void 0 : (_i$children$$children = _i$children$.children) === null || _i$children$$children === void 0 ? void 0 : _i$children$$children[0],
      [r] = p.position.split("-"),
      n = ["left", "right"].includes(r) ? "width" : "height";
    o && (o.style[n] = p.popper[n] * t / 100 + "px", setTimeout(() => {
      o.style.transition = e + "ms", o.style[n] = p.popper[n] + "px";
    }, 18));
  };
};